import styled from "styled-components";

const HomePageContainer = styled.div`
  width: 100%;
  max-width: 1024px;
  background: var(--fd-colors-background-surface);

  [data-qa-label="promosLegalContainer"] {
    color: var(--fd-colors-content-subtle);
  }

  @media only screen and (max-width: 599px) {
    overflow-x: hidden;

    [data-qa-label="promosLegalContainer"] {
      padding: 0 12px;
    }
  }

  @media only screen and (min-width: 768px) {
    [data-qa-label="promosFooterContainer"] {
      margin-top: 40px;
    }
  }

  @media only screen and (max-width: 767px) {
    [data-qa-label="promosFooterContainer"] {
      margin-top: 24px;
    }
  }

  @media only screen and (min-device-width: 1025px) and (orientation: landscape) {
    max-width: inherit;
  }
`;

export default HomePageContainer;
